import { useTranslation, withTranslation } from 'react-i18next';
import { Box, Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../../../../locales/keys';
import { postMessage } from '../../../../../utils/postMessage';

const useStyles = makeStyles((theme) => ({
  link: {
    fontWeight: 500,
    fontSize: '17px',
    letterSpacing: '0.2px',
    fontFamily: 'TitilliumWeb-Regular',
    WebkitFontSmoothing: 'auto',
    '&:hover': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  },
  confirmationTCInterlude: {
    display: 'inline',
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: '17px',
    letterSpacing: '0.2px',
    WebkitFontSmoothing: 'auto',
  },
}));

function ConfirmationField(props) {
  const { name, label } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={`field field--${name}`} mt={2}>
      <Typography variant="body2" color="textPrimary">
        <span>
          <span className={classes.confirmationTCInterlude}>
            {label || t(LocaleKeys.registration.confirmationTCPrelude)}
          </span>
          <Link
            data-testid="terms-and-condition-link"
            className={`${classes.link} `}
            color="textPrimary"
            underline="none"
            onClick={() => {
              postMessage('module.termsAndConditionsButton', {});
            }}
          >
            {t(LocaleKeys.registration.termsAndConditionsLink)}
          </Link>
          <span className={classes.confirmationTCInterlude}>
            {t(LocaleKeys.registration.confirmationTCPostlude)}
          </span>
        </span>
      </Typography>
    </Box>
  );
}

export default compose(withTranslation())(ConfirmationField);
